<template>
  <div
      :class="[b(), className]"
      :style="styleSizeName"
      ref="main"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @dblclick="handleDblClick"
      @click="handleClick"
  >
    <div :style="styleChartName">
      <div
          v-if="progressType == 'line'"
          style="width: 100%"
          :class="{ flex: option.suffixPosition }"
      >
        <div class="descriptionText">
          <div
              @click.stop="jump"
              :class="[b('text', {
                line: option.type === 'line',
                circle: option.type === 'circle',
              }),option.clickHandler && 'aida-progress-link']"
              :style="styleSuffixName"
              v-if="progressType == 'line'"
          >
            {{ progressData?.name || data?.name }}
            <el-tooltip
                effect="dark"
                v-if="firstMetric?.set?.indexTip"
                :content="firstMetric?.set?.indexTip"
                placement="top"
            >
              <el-icon>
                <QuestionFilled/>
              </el-icon>
            </el-tooltip>
          </div>
          <div :style="styleName" v-if="!option.suffixPosition">
            {{ percentageCom }}
          </div>
        </div>
        <el-progress
            style="flex: 1"
            :color="color"
            stroke-linecap="butt"
            :strokeWidth="strokeWidth"
            :width="option.circleSize"
            :height="option.circleSize"
            :percentage="isFinite(percentage) ? percentage : 0"
            :type="progressType"
            ref="progress"
            :striped="option.striped"
            striped-flow
            :duration="20"
        >
        </el-progress>
      </div>
      <div v-else>
        <el-progress
            :color="color"
            stroke-linecap="butt"
            :strokeWidth="strokeWidth"
            :width="option.circleSize"
            :height="option.circleSize"
            :percentage="isFinite(percentage) ? percentage : 0"
            :type="progressType"
            ref="progress"
        >
        </el-progress>
      </div>
    </div>
    <ChartNav @multiDrill="multiDrill" :currentDrillRouteIndex="currentDrillRouteIndex" @multiJump="multiJump"
              :multiActionsParam="multiActionsParam" v-model="drillIndex" :prop='prop'
              :option="option"
              :drillClickList="drillClickList"
              :drillDimList="drillDimList"></ChartNav>
  </div>
</template>

<script>
import create from "../../create";
import util from "@/option/common/util";

export default create({
  name: "progress",
  data() {
    return {
      progressData: this.data || {data: []},
      styleSuffixName: {},
      color: [],
      percentage: 0,
      strokeWidth: 14,
      progressType: "line",
      styleName: {},
      totalValue: this.option.totalValue,
    };
  },
  props: {
    option: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    firstMetric() {
      return this.prop.metrics?.[0]
    },
    percentageCom() {
      const data = isFinite(this.percentage) ? this.percentage : 0;
      const data_n = isFinite(this.progressData?.data[0])
          ? this.progressData?.data[0]
          : 0;
      if (this.totalValue === "--") {
        return "--";
      } else {
        return `${this.option.showPercentage ? data : data_n}${
            this.option.showPercentage ? "%" : this.option.unit || ""
        }`;
      }
    },
  },
  methods: {
    jump() {
      if (this.option.clickHandler) {
        let func
        try {
          func = eval(`(${this.option.clickHandler})`)
        } catch (e) {
          console.log(e)
        }
        func(this)
      }
    },
    setStyleName() {
      return {
        fontWeight: this.option.fontWeight || "normal",
        fontSize: (this.option.fontSize || (this.themeCfg?.chartSet?.seriesLabelSet?.size || 40)) + "px",
        color: this.option.color || (this.themeCfg?.chartSet?.seriesLabelSet?.color || "#333"),
        marginRight: "20px",
      };
    },
    setType() {
      return this.option.type || "line";
    },
    setStyleSuffixName() {
      return {
        fontWeight: this.option.suffixFontWeight || "normal",
        fontSize: (this.option.suffixFontSize || (this.themeCfg?.chartSet?.axisLabelSet?.size || 40)) + "px",
        color: this.option.suffixColor || (this.themeCfg?.chartSet?.axisLabelSet?.color || "#333"),
        margin: "0 10px",
      };
    },
    setColor() {
      return [
        {
          color: this.option.unachievedColor || "#333",
          percentage: this.option.unachievedValue || 0,
        },
        {color: this.option.achievedColor || "#333", percentage: 100},
      ];
    },
    setPercentage() {
      if (this.totalValue && this.progressData?.data[0]) {
        if (this.totalValue === "--") {
          return "--";
        }
        let numeratorLen = 0;
        if (this.progressData?.data[0].toString().indexOf(".") != -1) {
          numeratorLen = this.progressData?.data[0]
              .toString()
              .split(".")
              .pop().length;
        }
        const len = Math.min(
            numeratorLen,
            this.totalValue.toString().split(".").pop().length
        );
        return (
            (Number(this.progressData?.data[0]) / this.totalValue) *
            100
        ).toFixed(len);
      } else if (this.progressData?.data[0]) {
        let numeratorLen = 0;
        if (this.progressData?.data[0].toString().indexOf(".") != -1) {
          numeratorLen = this.progressData?.data[0]
              .toString()
              .split(".")
              .pop().length;
        }
        if (this.progressData?.data[0].toString().endsWith("%")) {
          return this.progressData?.data[0].split("%").join("");
        } else if (this.totalValue != 0) {
          return Number(this.progressData?.data[0]).toFixed(
              numeratorLen
          );
        }
      }
      return 0;
    },
    setStrokeWidth() {
      return this.option.strokeWidth || 14;
    },
    updateChart() {
      if (this.isDataCenter) {
        let {series} = this.getDimentionOption();
        series = series.map((item) => {
          let dimCode = this.dcode
          return {
            ...item,
            data: item.data.map((dataItem) => {
              const {code} =
              this.prop.metrics?.find(
                  (metItem) => metItem.name === item.name
              ) || {};
              return dataItem[code] || dataItem;
            }),
            name: item.data?.[0]?.[dimCode] || item.name
          };
        });
        this.progressData = series[0];
        if (this.option.totalValueFunc) {
          try {
            this.totalValue = new Function(`return ${this.option.totalValueFunc}`).call(this);
          } catch (e) {
            console.log(e)
          }
        } else if (
            Object.keys(this.dataChart).length &&
            Object.keys(this.dataChart[0]).length > 1
        ) {
          Object.keys(this.dataChart[0]).forEach((i) => {
            if (
                this.prop?.totalMetrics.length &&
                i == this.prop.totalMetrics[0].fieldKey
            ) {
              this.totalValue = this.dataChart[0][i];
            }
          });
        } else if (
            Object.keys(this.dataChart).length &&
            this.prop.totalMetrics.length
        ) {
          this.totalValue = this.progressData.data[0];
        } else {
          this.totalValue = this.option.totalValue;
        }
      } else {
        this.totalValue = this.option.totalValue;
        this.progressData = this.data;
      }
      this.progressType = this.setType();
      this.styleSuffixName = this.setStyleSuffixName();
      this.color = this.setColor();
      this.percentage = this.setPercentage();
      this.strokeWidth = this.setStrokeWidth();
      this.styleName = this.setStyleName();
      this.$nextTick(() => {
        const progressValueText =
            this.$refs.progress.$el.querySelector(".el-progress__text");
        if (this.option.type == "line") {
          progressValueText.style.display = this.option.suffixPosition
              ? "initial"
              : "none";
        }
        progressValueText.style.fontWeight = this.option.fontWeight || "normal";
        progressValueText.style.fontSize = (this.option.fontSize || 40) + "px";
        progressValueText.style.color = this.option.color || "#333";
        const progressBackground = this.$refs.progress.$el.querySelector(
            ".el-progress-circle__track"
        );
        if (progressBackground) {
          progressBackground.style.stroke =
              this.option.backgroundColor || "#fff";
        }
      });
    },
  },
});
</script>
<style>
.descriptionText {
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.aida-progress-link {
  cursor: pointer;
  text-decoration: underline;
}
</style>
